import {useApiMutation} from './api';
import {BulkFindAccounts} from '../../shared/api/definitions/root';
import {useIsMutating} from '@tanstack/react-query';

const BulkFindAccountsMutationKey = ['bulkFindAccounts'];

export const useBulkFindAccountsMutation = () => {
  return useApiMutation(BulkFindAccounts, {
    mutationKey: BulkFindAccountsMutationKey,
  });
};

export const useIsBulkFindAccountsLoading = () =>
  useIsMutating({
    mutationKey: BulkFindAccountsMutationKey,
  }) > 0;
